<template lang="pug">
v-radio-group.app-radio-group(:value="inputValue" v-bind="$attrs" ref="appRadioGroup")
  .pointer(
    v-for="(item, idx) in items"
    :key="idx"
    v-bind="containerProps"
    :class="getContainerClasses(item)"
    @click="choose(item)"
  )
    slot(name="prepend" v-bind="{ item, idx, isActive: isActive(item) }")

    v-radio.app-radio-group__radio(
      v-bind="extendRadioProps"
      :label="typeof item === 'object' ? item[keyLabel] : item"
      :value="typeof item === 'object' ? item[keyValue] : item"
      :color="typeof item === 'object' && item.color ? item.color : color"
      off-icon="$iradio-off"
      on-icon="$iradio-on"
    )
      template(#label)
        slot(name="label" v-bind="{ item, idx, isActive: isActive(item) }")

    slot(name="append" v-bind="{ item, idx, isActive: isActive(item) }")
</template>

<script>
export default {
  name: 'AppRadioGroup',

  props: {
    value: { type: [Number, String, Array], default: 0 },
    valueIsArray: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    keyValue: { type: String, default: 'value' },
    keyLabel: { type: String, default: 'label' },
    color: { type: String, default: 'redesignPrimary' },
    activeClassContainer: { type: [String, Array], default: '' },
    radioProps: { type: Object, default: () => ({}) },
    containerProps: { type: Object, default: () => ({}) },
    groupGap: { type: [Number, String], default: 0 },
    contrast: { type: Boolean, default: false },
  },

  computed: {
    inputValue: {
      get() {
        if (Array.isArray(this.value)) {
          const [first] = this.value;
          return first;
        }
        return this.value;
      },
      set(v) {
        if (Array.isArray(this.value) || this.valueIsArray) {
          this.$emit('input', [v]);
        } else this.$emit('input', v);
      },
    },
    extendRadioProps() {
      const { radioProps, contrast } = this;
      return {
        ...radioProps,
        class: [
          radioProps.class,
          contrast ? 'app-radio-group__radio--contrast' : '',
        ].flat(),
      };
    },
  },

  watch: {
    groupGap() {
      this.setGapToInputscontainer();
    },
  },

  mounted() {
    this.setGapToInputscontainer();
  },

  methods: {
    choose(item) {
      this.inputValue = typeof item === 'object' ? item[this.keyValue] : item;
    },
    isActive(item) {
      const currentValue = typeof item === 'object' ? item[this.keyValue] : item;
      return currentValue === this.value;
    },
    getContainerClasses(item) {
      return [this.containerProps?.class ? this.containerProps.class : '', this.isActive(item) ? this.activeClassContainer : ''].flat();
    },
    setGapToInputscontainer() {
      const { appRadioGroup } = this.$refs;
      const child = appRadioGroup?.$refs['input-slot']?.firstChild || null;
      if (child?.role === 'radiogroup') {
        child.style.gap = `${this.groupGap}px`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-radio-group {
  margin-top: 0;
  padding-top: 0;

  &::v-deep .v-input__slot {
    margin-bottom: 0;
  }

  &__radio {
    margin-right: 0 !important;
    margin-bottom: 0 !important;

    &--contrast {
      padding: 4px !important;
      border-radius: 8px !important;
      border: 1px solid #{$redesignBackground} !important;
    }

    &::v-deep .v-input--selection-controls__input {
      width: 20px;
      height: 20px;

      .v-icon__component {
        width: 20px;
        height: 20px;
      }
    }

    &::v-deep .v-input--selection-controls__ripple {
      display: none;
    }

    &::v-deep .v-icon {
      font-size: 20px;

      &:not(.mdi-radiobox-marked) {
        color: #{$redesignPrimary};
      }
    }

    &::v-deep .v-label {
      color: #{$redesignBlack};
      font-family: Inter;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}
</style>
